import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MediaChange, MediaObserver,  } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { AddQuizTextDialog } from './add-quiz-text/add-quiz-text.component';
import { DeleteConfirmationDialog } from 'src/app/shared/components/delete-confirmation/delete-confirmation.component';
import { DIFFICULTY, ITextQuizRow } from 'src/app/shared/models/lesson-content.model';

import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-quiz-text',
  templateUrl: './quiz-text.component.html',
  styleUrls: ['./quiz-text.component.scss']
})
export class QuizTextComponent implements OnInit {

	readonly difficulties = DIFFICULTY;

	texts!: ITextQuizRow[];

	@Input() set data(value: ITextQuizRow[]) {
		this.texts = value;
	}

	@Output() newData = new EventEmitter<ITextQuizRow[]>();

	cols: number = 0;
	gridByBreakpoint = {
		xl: 5,
		lg: 4,
		md: 3,
		sm: 2,
		xs: 1,
	}

	constructor(
		public dialog: MatDialog,
		private observableMedia: MediaObserver,
	) {
		this.cols = 5;
	}

	ngAfterContentInit() {
		this.observableMedia.asObservable().subscribe((change : MediaChange[]) => {
			for (let [key, value] of Object.entries(this.gridByBreakpoint)) {
				if (key === change[0].mqAlias) {
					this.cols = value;
				}
			}
		});
	}

	ngOnInit(): void {

	}

	remove(index: number) {
		const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
			width: "350px",
			data: index,
		});

		dialogRef.afterClosed().subscribe((result: boolean) => {
			if (!result) {
				return;
			}

			this.texts.splice(index, 1);
			this.sendData();
		});
	}

	addQuizText() {
		const dialogRef = this.dialog.open(AddQuizTextDialog, {
			width: '550px',
			data: {
				uuid: uuidv4(),
				statement: '',
				rightAnswer: '',
				wrongAnswers: [],
				difficulty: 1,
				isGrammar: false,
				text: '',
			} as ITextQuizRow,
		})

		dialogRef.afterClosed().subscribe((result: ITextQuizRow) => {
			if (!result) {
				return;
			}

			this.texts.push(result);
			this.sendData();
		})
	}

	sendData() {
		this.newData.emit(this.texts);
	}
}
